/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>登录遇到问题</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <el-form-item prop="contactPhone" label="手机号">
        <el-input clearable v-model="formInline.contactPhone" placeholder="请输入手机号"></el-input>
      </el-form-item>

      <el-form-item prop="status" label="状态 ">
        <el-select v-model="formInline.status" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="未处理" value="1"></el-option>
          <el-option label="已处理" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="platformType" label="反馈平台 ">
        <el-select v-model="formInline.platformType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option v-for="item in PlatformTypeOptions" :key="item.value" :value="item.value"
                     :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="operatorUserId" label="审核人员">
        <el-select clearable v-model="formInline.operatorUserId" placeholder="请选择">
          <el-option

            v-for="item in SelectList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item prop="beginCreateTime" label="反馈时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                          v-model="formInline.beginCreateTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endCreateTime">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                            placeholder="选择日期" v-model="formInline.endCreateTime"
                            style="width: 100%;"></el-date-picker>
          </el-form-item>


        </el-col>
      </el-form-item>
      <el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="success" @click="resetForm('formInline')">重置</el-button>

        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>




    </el-form>
    <el-table id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"

              @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
              style="width: 100%; font-size: 18px;">
      <el-table-column prop="contactPhone" align="center" label="手机号" width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.phone, userifom|mobileStr }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="problemDetail" align="center" label="问题表述" width="450">
        <template slot-scope="scope">
          <div style="height: 100px;">{{ scope.row.problemDetail }}</div>
        </template>


      </el-table-column>

      <el-table-column prop="image" align="center" label="问题截图" width="180">

        <template slot-scope="scope">
          <el-image
            v-if="scope.row.image"
            style="width: 80px; height: 80px;"
            :src="scope.row.image?scope.row.image[0]:'https://dev-miniapp-1304146125.cos.ap-beijing.myqcloud.com/accountDefaultHeadIcon.png'"

            :preview-src-list="scope.row.image"/>
          <span v-else>暂无反馈图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="version" align="center" label="反馈时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime|timestampToTime }}</div>
          <br>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="registerTypeDesc" label="注册类型" width="180">
      </el-table-column>

      <el-table-column prop="status" align="center" label="反馈平台" width="150">
        <template slot-scope="scope">
          <div style="color: #F9AD00;">{{ scope.row.platformType == 1 ? '微信小程序' : "抖音小程序" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" align="center" label="状态" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.status==1" style="color: #F9AD00;">未处理</div>
          <div v-if="scope.row.status==2" style="color: #34D0B4;">已处理</div>
        </template>
      </el-table-column>
      <el-table-column prop="results" align="center" label="处理结果" width="290">
      </el-table-column>
      <el-table-column prop="operatorUserName" label="操作人员" width="150">
      </el-table-column>
      <el-table-column prop="updateTime" align="center" label="操作时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.updateTime|timestampToTime }}</div>
          <br>

        </template>
      </el-table-column>


      <el-table-column prop="version" align="center" label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status==1" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-thumb"
                     type="primary">处理
          </el-button>
          <el-button v-if="scope.row.status==2" type="info">已处理</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!--列表-->

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
                @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->


    <el-dialog
      @close="centerDialogVisiblefalse"
      title="处理结果"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span style="margin-bottom: 20px;">客服回复内容</span>
      <el-input
        style="margin-top: 20px;"

        type="textarea"
        placeholder="请描述用户所遇到的问题，是否已经电话联系"
        v-model="textarea"
        maxlength="2000"
        show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisiblefalse">取 消</el-button>
    <el-button type="primary" @click="oncenterDialogVisible">确 定</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>

import {deptList, deptSave, deptDelete} from '../../api/userMG'
import Axios from 'axios'
import Vue from 'vue'


import {login} from "../../api"

let tokenId = localStorage.getItem('tokenId');
import {mobileStr} from "../../utils/util"

import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";

export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      file_list: [],
      id: '',
      userifom: "",
      ssoServer: "",
      textarea: "",
      centerDialogVisible: false,
      hideUpload: false,
      dialogVisibles: false,
      dialogVisibleimg: false,
      dialogImageUrl: '',
      dialogVisible: false,

      uploadDisabled: false,
      hideUpload_introduce: false,
      limitCount: 1,
      indexs: "",
      formInline: {
        platformType: "",
        contactPhone: "",
        operatorUserId: "",
        beginCreateTime: "",
        endCreateTime: "",
        status: "",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },

      dialogFormVisibleicn: false,
      activeName: '1',
      userlist: "",
      radio: "",

      dialogFormVisible: false,
      checkList: [],
      options123: [],
      undataList: "",
      options1234123: [],
      fileList: [],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加banner',

      SelectList: "",
      editForm: {
        id: "",
        status: "",
        addressType: "1",
        addDeer: "",
        url: "",
        title: "",
        beginTime: "",
        type: "",
        path: [],
        orders: "",
        deptId: '',
        endTime: "",
      },

      // rules表单验证
      rules: {
        addDeer: [
          {required: true, message: '请选择位置', trigger: 'blur'}
        ],
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
        path: [{required: true, message: '请选择图片', trigger: 'blur'}],
        type: [{required: true, message: '请选择类型', trigger: 'blur'}],

        beginTime: [{required: true, message: '开始时间不能为空', trigger: 'blur'}],
        endTime: [{required: true, message: '结束时间不能为空', trigger: 'blur'}],
        orders: [{required: true, message: '排序不能为空', trigger: 'blur'}],
        url: [{required: true, message: '参数链接不能为空', trigger: 'blur'}]


      },
      adder: "",

      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId


    Axios({
        method: 'get',
        url: this.ssoServer+'/api/platform-user/getSelectList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.SelectList =res.data.data
        console.log(res);

      })

    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()
    this.userifom= localStorage.getItem('userifom');


   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    centerDialogVisiblefalse(){
      this.centerDialogVisible=false
      this.textarea=''

    },

    oncenterDialogVisible(){

        if(this.textarea==''){
        this.$message({
              type: 'warning',
              message: '回复内容不能为空!!!'
            })
            return
    }

        Axios({
  method: 'post',
  url: this.ssoServer+'/api/platform-login-problem/handleProblem',
  headers:{
    tokenId:this.adder
        },
  data: {
    id:this.id,
    results:this.textarea
  }
}).then(res=>{

  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
  if(res.data.code=='0'){
    this.centerDialogVisible=false
        this.$message({
            type: 'success',
            message: '处理成功'
          })
          this.textarea=''
          this.formLIst()

  }
  // console.log(res);
})

    },
    uploadSectionFile(f,g){
      if (g.length >= 1) {
      this.uploadDisabled = true;
    }


      this.hideUpload = true;
    },

    handleAvatarSuccess(res, file) {

      // console.log(res.data,file);

        this.editForm.path = res.data
        this.hideUpload = false;
      },

    // 添加图片
    handleRemove(file, fileList) {

      this.uploadDisabled = false;
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;

       this.dialogVisibleimg=true
        // this.editForm.path = file.url;
        // console.log(file);
        // this.dialogVisible = true;
      },
    //添加

    // 确定审核
    OndialogVisible(){

        Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-nick-name-check/operate',
        headers:{
          tokenId:this.adder
        },
        data:{
        //   appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId:1,

        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogVisible=false
          this.$message({
         type: 'success',
         message: '审核成功'
       })
       this.formLIst()
    }
})





    },
  // 查看历史图片
  historyHeadIcons(item){
    this.historyHea =item
    // console.log(item);
    this.dialogFormVisibleicn=true

  },
    // 颜值打分
    YZdialogFormVisible(){
      if(!this.radio){
        this.$message({
         type: 'warning',
         message: '选择不能为空'
       })
       return
      }
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-head-icon-check/operate',
        headers:{
          tokenId:this.adder
        },
        data:{
          appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId:1,

        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
         type: 'success',
         message: '打分成功'
       })
       this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

    },
    handleCheckedCitiesChange(){
      console.log(this.checkList);
    },
    caozClick(){
      if(this.importList.length==0){
        this.$message({
         type: 'warning',
         message: '请选择要审核的用户'
       })
       return

      }else{
        this.dialogVisible=true
        console.log('1111');
      }

    },

    handleClick(tab, event) {
    //  return  console.log(this.activeName);
     if(this.activeName==1){
      this.formInline.status=1
        this.formLIst()
     }else if(this.activeName==2){
      this.formInline.status=2
        this.formLIst()
     }else if(this.activeName==3){
      this.formInline.status=3
        this.formLIst()
     }

      },

    getAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },

    handleEdit(index, row) {
        this.id =row.id

      this.centerDialogVisible = true
    //
    },
    addOnclick(index,row){
      this.editFormVisible=true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑banner'
        this.editForm.roleId = row.roleId
        this.editForm.systemNo = row.systemNo
        this.editForm.roleNo = row.roleNo
        this.editForm.roleName = row.roleName
      } else {
        this.title = '添加banner'
        this.editForm.roleId = ''
        this.editForm.systemNo = ''
        this.editForm.roleNo = ''
        this.editForm.roleName = ''
      }
      // this.indexs=1
      // if (this.indexs==1) {
      //   this.title='添加banner'
      //   this.editFormVisible=true
      // }

    },
    selectalls(rows) {
      this.userlist =rows
      this.indexs=2
      if (this.indexs==2) {
        this.title='编辑banner'

        let add = String(rows.type)
      //  return  console.log(add);

      this.editFormVisible=true
      this.editForm =this.userlist
      this.editForm.type=add
      this.editForm
      }

      // this.undataList =rows

   console.log(rows);
    },


              onChange(e){

                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);


              },
              onChanges(e){
                this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    selectall(val){
        console.log(val);

      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

      // this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      if(this.importList.length==0){

       this.$message({
         type: 'warning',
         message: '请选择要导出的数据'
       })
       return

     }else{
             Axios({
 method: 'post',

 url: this.ssoServer+'/api/platform-account/exportExcel',
 headers:{
  tokenId:this.adder
        },
 data: {
   accountIds: this.importList
 },
 responseType: 'blob'
}).then(res => {
 const link = document.createElement('a') // 创建a标签
 const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
 link.href = window.URL.createObjectURL(blob)
 const filename = res.headers['content-disposition'].split('filename=')[1]
 link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
 link.click()
 window.URL.revokeObjectURL(link.href)
})


     }




    },
    select(selection, row){

      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
        this.$refs[formInline].resetFields();
      },


    formLIst(){
      Axios({
  method: 'get',

  url: this.ssoServer+'/api/platform-login-problem/getList',
  headers:{
    tokenId:this.adder
        },
  params:this.formInline
}).then(res=>{
    this.listData =res.data.data.list
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
          console.log(res.data.data.list);

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total

})

    },
    formatData(row, column, cellValue, index){

		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,

      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
        // .then(res => {
        //   console.log(res);
        //   this.loading = false
        //   if (res.success == false) {
        //     this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   } else {
        //     this.listData = res.data
        //     // 分页赋值
        //     this.pageparm.currentPage = this.formInline.current
        //     this.pageparm.pageSize = this.formInline.size
        //     this.pageparm.total = res.count
        //   }
        // })
        // .catch(err => {
        //   this.loading = false
        //   this.$message.error('菜单加载失败，请稍后再试！')
        // })
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },

    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(editForm) {
      this.fileList=[]
      // this.$refs[editForm].resetFields();
      this.editFormVisible = false
    }
  }
}
</script>

<style>


.disabled .el-upload--picture-card {
  display: none !important;
}




.dialogForm{
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .dialogFormChl{
    margin-top: 20px;
    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    /* height: 300px */

  }
  .dialogFormChl img{
   width: 100%;
   /* height: 200px; */
  }
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/system/Signissues.vue